import { Flex } from 'antd';

import * as images from '../../assets/family-link/images';

export function FamilyLinkBadges() {
  return (
    <>
      <Flex align="center" gap={10} className="familylink__badges">
        <images.CalendarTick className="familylink__badges-icon" />
        <p>A FamilyLink® player has full access to site content 24/7.</p>
      </Flex>
      <Flex align="center" gap={10} className="familylink__badges">
        <images.EyeSlashIcon className="familylink__badges-icon" />
        <p>
          The free User ID appears on the Homepage of the student&apos;s school
          account; click SHOW PASSWORD to begin using the free account.
        </p>
      </Flex>
      <Flex align="center" gap={10} className="familylink__badges">
        <images.GoalFlagIcon className="familylink__badges-icon" />
        <p>
          FamilyLink Players can compete with other FL players, but their scores
          [stickers] are not included with School data.
        </p>
      </Flex>
    </>
  );
}
